import { checkNumber } from './index';

// 把时间戳转成日期格式
/*eslint-disable*/
export const formatDate = function (date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return `${year}-${String(month).length > 1 ? month : `0${month}`}-${
    String(day).length > 1 ? day : `0${day}`
  } ${String(hour).length > 1 ? hour : `0${hour}`}:${
    String(minute).length > 1 ? minute : `0${minute}`
  }:${String(second).length > 1 ? second : `0${second}`}`;
};

// 获取当前月份之后的月份数组
export const formatMonthList = function () {
  const list = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  // eslint-disable-next-line prefer-destructuring
  const currentMonth = formatDate(new Date()).split(' ')[0].split('-')[1];
  const index = parseInt(currentMonth);
  return list.slice(index - 1);
};

// 格式化日期格式 暂时未测
let oldDateNum = ''; // 上一次日期

export const formateDateOf = function (e) {
  const { value } = e.target;

  if (value) {
    const { length } = value;
    // 排除正在删除值的情况
    if (length === 2 && checkNumber(value) && oldDateNum - length < 0) {
      this.modalValue[field] = `${value}/`;
    }
    let list = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    const currentYear = this.formatDate(new Date()).split(' ')[0].split('-')[0].slice(2);

    if (value.length > 1 && list.indexOf(value.slice(0, 2)) === -1) {
      // 校验月份
      this.dateInvalid = true;
    }
    // 前两位是月份，后两位是年份
    if (value.length > 4) {
      // 校验年份
      const year = value.slice(3);
      if (year - currentYear < 0) {
        this.dateInvalid = true;
      } else if (year === currentYear) {
        list = this.formatMonthList();
        if (list.indexOf(value.slice(0, 2)) === -1) {
          this.dateInvalid = true;
        }
      }
    }
    oldDateNum = value.length;
  }
};
